$(function () {
    if ($('form#MangeMultipleEnrolmentsForm').length > 0) {

        $("#btnSave").on('click', function (e) {
            e.preventDefault();
            e.stopPropagation();

            var isValid = true;
            $("input:radio").each(function () {
                var name = $(this).attr("name");
                if ($("input:radio[name=" + name + "]:checked").length == 0) {
                    $("#RadiobuttonNotSelected-error").removeClass('d-none');
                    isValid = false;
                }
            });

            var ids = [];
            $(".detailId:checked").each(function (e) {
                ids.push($(this).data('perm'));
            });

            console.log(ids);

            $("#DetailIdsToProcess").val(ids.join(','));

            if (isValid)
            {
                $('#MangeMultipleEnrolmentsForm')[0].submit();
            }
        });


        $(document).on('click', '.btnCancel', function (e) {
            var url = '';
            var self = $(this);
            var oper;
            var licence;
            var id;

            oper = self.data('oper');
            licence = self.data('licence');
            id = self.data('submissionid');


            if (location.href.indexOf('/en/') > 0) {
                url = location.href.split('/en/')[0] + '/en/feesubsidy/home/licensesummary/' + oper + '/' + licence + '/' + id + '/';
            } else {
                url = location.href.split('/fr/')[0] + '/fr/feesubsidy/home/licensesummary/' + oper + '/' + licence + '/' + id + '/';
            }

            $.ajax({
                url: url,
                method: 'POST',
                contentType: false,
                processData: false,
                success: function (res) {
                    window.location.href = url;
                },
                error: function () {
                    window.location.href = url;
                }
            });
        });

    } 
}); 